module.exports = __webpack_public_path__ + "static/media/ui-virtual-event.6ada36c1.png";